export enum InviteUserRolesEnum {
  ADMIN = 'admin',
  SOCIAL_MANAGER = 'social_manager',
  VIEW_ONLY = 'view_only'
}
